import { Pagination as AntPagination } from 'antd';

interface PaginationProps {
  total: number;
  page: number;
  pageSize: number;
  onChange: (page: number, pageSize: number) => void;
  /** Default page sizes: 50 for call lists, 25 for admin tables (architecture §4.5). */
  pageSizeOptions?: number[];
}

/** Server-side pagination control. The parent owns page state and refetches on change. */
export default function Pagination({
  total,
  page,
  pageSize,
  onChange,
  pageSizeOptions = [25, 50, 100],
}: PaginationProps) {
  return (
    <AntPagination
      align="end"
      style={{ marginTop: 16 }}
      total={total}
      current={page}
      pageSize={pageSize}
      showSizeChanger
      pageSizeOptions={pageSizeOptions}
      showTotal={(t) => `${t} مورد`}
      onChange={onChange}
    />
  );
}
